import React, { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";

const AuthCallback = ({ onDone }) => {
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    const process = async () => {
      if (!sessionId) {
        setError("No session found.");
        return;
      }
      try {
        await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        window.history.replaceState(null, "", "/");
        window.location.href = "/journey";
      } catch (e) {
        setError("Sign in failed. Please try again.");
      }
    };
    process();
  }, [onDone]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background" data-testid="auth-callback">
      <Loader2 className="w-8 h-8 text-primary animate-spin mb-4" />
      <p className="text-muted-foreground font-medium">
        {error ? error : "Completing sign in\u2026"}
      </p>
    </div>
  );
};

export default AuthCallback;
